import { CSSObject } from "styled-components";
import { vfxTheme } from "../VFX-UI/Theme/theme";

interface ActionBarStyles {
  buttonGroup: CSSObject;
  deleteButton: CSSObject;
  editButton: CSSObject;
  flexGrow: CSSObject;
  label: CSSObject;
  cancelButton: CSSObject;
  padding: CSSObject;
  saveButton: CSSObject;
  submitButton: CSSObject;
  submitWithLoadingIndicator: CSSObject;
  submitTextInsideIndicator: CSSObject;
  submitButtonDisabled: CSSObject;
  loadingIndicator: CSSObject;
  customButtonContainerStyle: CSSObject;
  customButtonImageStyle: CSSObject;
}

export const useBottomFormStyles = (): ActionBarStyles => {
  
  return {
    buttonGroup: {
      borderTop: `1px solid ${vfxTheme.palette.blueGreys.bg50}`,
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "25px",
    },
    customButtonContainerStyle: {
      borderRadius:20,
        padding: 0, 
        backgroundColor: "transparent",
    },
    customButtonImageStyle: {
      maxHeight: 100
    },
    deleteButton: {
      backgroundColor: vfxTheme.palette.reds.r50,
      color: vfxTheme.palette.reds.r800,
      fontWeight: vfxTheme.fontWeights.bold,
    },
    editButton: {
      backgroundColor: vfxTheme.palette.blues.b50,
      color: vfxTheme.palette.blues.b700,
      fontWeight: vfxTheme.fontWeights.bold,
    },
    flexGrow: {
      flexGrow: 1,
    },
    label: {
      fontSize: vfxTheme.spaceUnits.sp03,
      paddingBottom: vfxTheme.spaceUnits.sp01,
    },
    cancelButton: {
      backgroundColor: vfxTheme.palette.background.default,
      color: vfxTheme.palette.blues.b500,
      fontWeight: vfxTheme.fontWeights.bold,
      marginLeft: vfxTheme.spaceUnits.sp04,
      marginRight: vfxTheme.spaceUnits.sp00,
    },
    padding: {
      padding: vfxTheme.spaceUnits.sp03,
    },
    saveButton: {
      color: vfxTheme.palette.primary.main,
      fontWeight: vfxTheme.fontWeights.bold,
      marginLeft: vfxTheme.spaceUnits.sp04,
      marginRight: vfxTheme.spaceUnits.sp00,
    },
    submitButton: {
      backgroundColor: vfxTheme.palette.primary.main,
      color: vfxTheme.palette.background.default,
      fontWeight: vfxTheme.fontWeights.bold,
      marginLeft: vfxTheme.spaceUnits.sp04,
      marginRight: vfxTheme.spaceUnits.sp00,
    },
    submitWithLoadingIndicator: {
      display: "flex",
      alignItems: "center",
    },
    submitTextInsideIndicator: {
      marginLeft: vfxTheme.spaceUnits.sp01,
    },
    submitButtonDisabled: {
      backgroundColor: vfxTheme.palette.blueGreys.bg50,
      color: vfxTheme.palette.blueGreys.bg100,
      fontWeight: vfxTheme.fontWeights.bold,
      marginLeft: vfxTheme.spaceUnits.sp04,
      marginRight: vfxTheme.spaceUnits.sp04,
    },
    loadingIndicator: {
      display: "flex !important",
    },
  };
};
